import { getLocalStorage } from '../../utils';

export const logout = () => {
  getLocalStorage().removeItem('token');
  getLocalStorage().removeItem('refresh_token');
  getLocalStorage().removeItem('impersonated_token');
};
